@if (breakpointService.isDesktop()) {
    <div class="hotels">
        <div class="hotels__title">
            <h2 class="container--title">
                {{ currentCity?.cityName }} Hotels: {{ hotelsAmount }} hotels
            </h2>
            <p class="container--title">by</p>
            <img
                    src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/images/booking.png?_a=ATFGlAA0"
                    alt="booking-logo">
        </div>

        @if (showFilters) {
            <mat-select placeholder="Sorting" [formControl]="getSortControl" class="default-button sorting-button">
                @for (option of sortingOptions; track option.value) {
                    <mat-option [value]="option.value">{{ option.text }}</mat-option>
                }
            </mat-select>
        }
        <div class="hotels__actions">
            <button [disabled]="isFetching()" class="btn-default default-button toggle-map-button"
                    (click)="toggleAllHotelsOnMap()">
                {{ openedMap ? 'Close map' : 'Show on map' }}
            </button>
            <button class="f-row f-center f-v-center btn-default default-button wishlist-button"
                    (click)="showFavouriteHotels()">Show my hotel wishlist
                <img src="assets/images/heart-icon.png" alt="" class="favorite-box--icon">
            </button>
        </div>
    </div>

    @if (showInfoBlueLabel) {
        <div class="info-blue">
            <div class="info-blue__empty"></div>
            <div class="info-blue__content">
                <div class="info-blue__text">
                    Book accommodations and get all RoutePerfect’s travel perks and advantages.
                </div>
                @if (!authService.userId) {
                    <button class="btn-default info-blue__button" (click)="authService.checkLogin()">
                        Sign up to get more
                    </button>
                }
            </div>
        </div>
    }

    <app-filters-wrapper
            [wrapperClass]="['mt-0']"
            [showFilterSection]="showFilters"
            [openedMap]="openedMap"
            (onCloseMap)="toggleAllHotelsOnMap()"
            (onFiltersToggle)="toggleShowFiltersOnBox()">
        @if (showFilters) {
            <ng-container filters>
                <div class="search-box">
                    <input
                            type="text"
                            class="search-box__input"
                            placeholder="Search accommodations"
                            aria-label="Search accommodations"
                            [formControl]="searchControl"
                            [matAutocomplete]="auto"
                    />
                    <mat-autocomplete #auto="matAutocomplete">
                        @for (option of filteredHotels | async; track $index) {
                            <mat-option
                                    [value]="option.name"
                                    (onSelectionChange)="setHighlightBySelectedIndex(option.id, true)">
                                {{ option.name }}
                            </mat-option>
                        }
                    </mat-autocomplete>
                    @if (!searchControl.value) {
                        <span class="search-box__search-icon"></span>
                    } @else {
                        <button
                                class="search-box__clear-btn"
                                (click)="handleClearSearchControl()"
                        ></button>
                    }
                </div>
                <form [formGroup]="filterForm">
                    <div class="f-row f-between">
                        <mat-select formControlName="stars" placeholder="Class" class="half" multiple>
                            <mat-select-trigger>
                            <span style="display: flex; align-items: center;">
                              Class: {{ getCustomTriggerText(filterForm.get('stars'), starsOptions) }}
                                <mat-icon style="width: 16px; height: 16px; margin-left: 3px;"
                                          [svgIcon]="eSvgIcons.HOTEL_STAR"></mat-icon>
                            </span>
                            </mat-select-trigger>
                            @for (star of starsOptions; track star.value) {
                                <mat-option [value]="star.value">
                                    <div class="stars">
                                        @for (start of generateArr(star.text); track $index) {
                                            <mat-icon [svgIcon]="eSvgIcons.HOTEL_STAR"></mat-icon>
                                        }
                                    </div>
                                </mat-option>
                            }
                        </mat-select>
                        <mat-select formControlName="score" placeholder="Rating" class="half">
                            <mat-select-trigger>
                                Rating: {{ filterForm.get('score').value ? filterForm.get('score').value + "+" : "" }}
                            </mat-select-trigger>
                            @for (star of scoreOptions; track star.value) {
                                <mat-option [value]="star.value">{{ star.text }}</mat-option>
                            }
                        </mat-select>
                    </div>
                    @if (!partialFilters) {
                        <div class="custom-mat-select price-select" #origin (click)="showPriceRangePanel(origin)">
                            Price range
                            {{ getFormattedPriceRange() }}
                        </div>
                    }
                    <mat-select formControlName="type" placeholder="Accommodations" multiple>
                        <mat-select-trigger>
                            Accommodations: {{ getCustomTriggerText(filterForm.get('type'), accomondationOptions) }}
                        </mat-select-trigger>
                        @for (star of accomondationOptions; track star.value) {
                            <mat-option [value]="star.value">{{ star.text }}</mat-option>
                        }
                    </mat-select>
                    <mat-select formControlName="facilities" placeholder="Facilities" multiple>
                        <mat-select-trigger>
                            Facilities: {{ getCustomTriggerText(filterForm.get('facilities'), facilitiesOptions) }}
                        </mat-select-trigger>
                        @for (star of facilitiesOptions; track star.value) {
                            <mat-option [value]="star.value">{{ star.text }}</mat-option>
                        }
                    </mat-select>
                    @if (!partialFilters) {
                        <div class="checkbox-filter-container">
                            <div class="checkbox-filter-container--title">
                                Popular filters
                            </div>
                            <div class="f-col">
                                <mat-checkbox formControlName="refundable">Free cancellation</mat-checkbox>
                                <mat-checkbox formControlName="breakfastIncluded">Breakfast included</mat-checkbox>
                            </div>
                        </div>
                    }
                </form>
            </ng-container>
        }

        <div content class="hotels-col">
            @if (isFetching()) {
                @for (row of fetchingItems; track $index) {
                    <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="405" class="f-row">
                        <ng-container *cdkVirtualFor="let item of row">
                            <app-booking-hotel-card
                                    [hotelData]="item"
                                    [cityId]="currentCity?.id"
                                    [countryName]="currentCountry?.countryName"
                                    [cityName]="currentCity?.cityName"
                                    [isFetching]="true"
                            ></app-booking-hotel-card>
                        </ng-container>
                    </cdk-virtual-scroll-viewport>
                }
            } @else {
                @if (hotelsAmount) {
                    @for (row of hotelRows(); track row) {
                        <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="405" class="f-row">
                            <ng-container *cdkVirtualFor="let item of row">
                                <app-booking-hotel-card
                                        [hotelData]="item"
                                        [cityId]="currentCity?.id"
                                        [countryName]="currentCountry?.countryName"
                                        [cityName]="currentCity?.cityName"
                                ></app-booking-hotel-card>
                            </ng-container>
                        </cdk-virtual-scroll-viewport>
                        @if (currentIndex > 0) {
                            <button mat-icon-button (click)="scrollTo(-scrollByRows)" class="button-absolute left">
                                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
                            </button>
                        }
                        @if (currentIndex < maxScrollIndex) {
                            <button mat-icon-button (click)="scrollTo(scrollByRows)" class="button-absolute right">
                                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
                            </button>
                        }
                    }
                } @else {
                    <app-no-items-found title="EMPTY.HOTELS"></app-no-items-found>
                }
            }
        </div>

        <div map style="width: 100%; height: 100%; border-radius: 12px; overflow: hidden">
            <app-hotels-map
                    [hotels]="hotelsOnMap()"
                    (selectedHotelIndex)="setHighlightBySelectedIndex($event)"
            ></app-hotels-map>
        </div>
    </app-filters-wrapper>
} @else {
    <app-hotel-list-mobile
            [isFetching]="isFetching()"
            [cityId]="currentCity?.id"
            [cityName]="currentCity?.cityName"
            [countryName]="currentCity?.countryName"
            [hotels]="hotelRows()[0]"
    ></app-hotel-list-mobile>
}
